const l = {
  showAccelerationAndTopSpeed: {
    NL: !1,
    DEFAULT: !0
  },
  // NOTE: UK specific to display extra leasing attributes
  showAdditionalLeasingOptions: {
    GB: !0,
    DEFAULT: !1
  },
  showAdvancedLeasingPayment: {
    BE: !1,
    FR: !1,
    NL: !1,
    DEFAULT: !0
  },
  showCompanyRegistrationNumberField: {
    AT: !1,
    CH: !1,
    DE: !1,
    ES: !1,
    GB: !1,
    DEFAULT: !0
  },
  showEcoBonusForLeasingPaymentType: {
    AT: !0,
    DEFAULT: !1
  },
  // NOTE: NL specific to hide EU_TireLabel classification codes
  showEUTireLabelMeasuredValueAndWetGripClasses: {
    AT: !1,
    NL: !1,
    DEFAULT: !0
  },
  showExtraEnergyLabelsCustomizer: {
    CH: !0,
    DEFAULT: !1
  },
  showLeasingLogotype: {
    NL: !0,
    DEFAULT: !1
  },
  showLeasingTotalAmount: {
    AT: !1,
    BE: !1,
    CH: !1,
    ES: !1,
    FR: !1,
    GB: !1,
    IT: !1,
    NL: !1,
    DEFAULT: !0
  },
  showLeasingTransportationAndRegistrationCost: {
    AT: !1,
    BE: !1,
    ES: !1,
    FR: !1,
    GB: !1,
    IT: !1,
    NL: !1,
    DEFAULT: !0
  },
  showLeasingTransportationAndRegistrationCostInOrderOverviewSummary: {
    AT: !1,
    BE: !1,
    ES: !1,
    FR: !1,
    GB: !1,
    IT: !1,
    NL: !1,
    DEFAULT: !0
  },
  showLeasingTransportationAndRegistrationCostInVehiclePaymentDetails: {
    BE: !1,
    ES: !1,
    FR: !1,
    GB: !1,
    IT: !1,
    NL: !1,
    DEFAULT: !0
  },
  showListPriceForLeasingPaymentType: {
    AT: !0,
    NL: !0,
    DEFAULT: !1
  },
  showOnlyTotalGrossPrice: {
    AT: !0,
    DEFAULT: !1
  },
  showOnTheRoadPriceSubtotal: {
    GB: !0,
    DEFAULT: !1
  },
  showOtherPaymentTypesLabel: {
    GB: !0,
    DEFAULT: !1
  },
  showSubTotalPriceForLeasingPaymentType: {
    AT: !0,
    DEFAULT: !1
  },
  showVatNumberB2C: {
    AT: !1,
    BE: !1,
    FR: !1,
    DE: !1,
    NL: !1,
    CH: !1,
    GB: !1,
    DEFAULT: !0
  },
  showVehiclePriceForLeasingPaymentType: {
    AT: !1,
    NL: !1,
    DEFAULT: !0
  }
}, t = {
  AT: {
    vehicleDetails: {
      LEASING: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePrice: 3,
        environmentalBonus: 4,
        subTotalPrice: 5,
        leasingDuration: 6,
        mileage: 7,
        downPayment: 8,
        leasingPayment: 9
      },
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePriceCashBuy: 3,
        environmentalBonus: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    orderSummary: {
      LEASING: {
        totalLeasingCost: 1,
        downPayment: 2,
        annualMileageAndDuration: 3
      },
      CASHBUY: {
        subTotalPrice: 1
      }
    },
    pdf: {
      LEASING: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePrice: 3,
        environmentalBonus: 4,
        subTotalPrice: 5,
        leasingDuration: 6,
        mileage: 7,
        downPayment: 8,
        leasingPayment: 9
      },
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePriceCashBuy: 3,
        environmentalBonus: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    }
  },
  GB: {
    vehicleDetails: {
      LEASING: {
        leasingPayment: 1,
        downPayment: 2,
        advancedMonth: 3,
        leasingDuration: 4,
        mileage: 5,
        optionalFinalPayment: 6,
        optionToPurchaseFee: 7,
        totalCreditAmount: 8,
        totalAmountPayable: 9,
        excessMileage: 10,
        representativeAPR: 11,
        interestRatePerAnnum: 12
      },
      FINANCE: {
        representativeExample: 1,
        leasingPayment: 2,
        downPayment: 3,
        mileage: 4,
        leasingDuration: 5,
        vehiclePrice: 6,
        optionalFinalPayment: 7,
        optionToPurchaseFee: 8,
        totalCreditAmount: 9,
        totalAmountPayable: 10,
        excessMileage: 11,
        representativeAPR: 12,
        interestRatePerAnnum: 13
      },
      CASHBUY: {
        listPrice: 1,
        environmentalBonus: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        onTheRoadCostsSubtotal: 5,
        packagesAttributes: 6,
        subTotalPrice: 7
      }
    },
    orderSummary: {
      LEASING: {
        leasingPayment: 1,
        downPayment: 2,
        advancedMonth: 3,
        leasingDuration: 4,
        mileage: 5,
        optionalFinalPayment: 6,
        optionToPurchaseFee: 7,
        totalCreditAmount: 8,
        totalAmountPayable: 9,
        excessMileage: 10,
        representativeAPR: 11,
        interestRatePerAnnum: 12
      },
      FINANCE: {
        representativeExample: 1,
        leasingPayment: 2,
        downPayment: 3,
        mileage: 4,
        leasingDuration: 5,
        vehiclePrice: 6,
        optionalFinalPayment: 7,
        optionToPurchaseFee: 8,
        totalCreditAmount: 9,
        totalAmountPayable: 10,
        excessMileage: 11,
        representativeAPR: 12,
        interestRatePerAnnum: 13
      },
      CASHBUY: {
        listPrice: 1,
        environmentalBonus: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        onTheRoadCostsSubtotal: 5,
        packagesAttributes: 6,
        subTotalPrice: 7
      }
    },
    pdf: {
      LEASING: {
        leasingPayment: 1,
        downPayment: 2,
        advancedMonth: 3,
        leasingDuration: 4,
        mileage: 5,
        optionalFinalPayment: 6,
        optionToPurchaseFee: 7,
        totalCreditAmount: 8,
        totalAmountPayable: 9,
        excessMileage: 10,
        representativeAPR: 11,
        interestRatePerAnnum: 12
      },
      FINANCE: {
        representativeExample: 1,
        leasingPayment: 2,
        downPayment: 3,
        mileage: 4,
        leasingDuration: 5,
        vehiclePrice: 6,
        optionalFinalPayment: 7,
        optionToPurchaseFee: 8,
        totalCreditAmount: 9,
        totalAmountPayable: 10,
        excessMileage: 11,
        representativeAPR: 12,
        interestRatePerAnnum: 13
      },
      CASHBUY: {
        listPrice: 1,
        environmentalBonus: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        onTheRoadCostsSubtotal: 5,
        packagesAttributes: 6,
        subTotalPrice: 7
      }
    }
  },
  IT: {
    vehicleDetails: {
      LEASING: {
        vehiclePrice: 1,
        onTheRoadAdditionalCosts: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        downPayment: 6,
        leasingPayment: 7
      },
      CASHBUY: {
        listPrice: 1,
        environmentalBonus: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        vehicleTireTax: 5,
        vehicleEffectivePrice: 6,
        packagesAttributes: 7,
        winterTireTax: 8,
        orderDiscount: 9,
        subTotalPrice: 10
      },
      FINANCE: {}
    },
    orderSummary: {
      LEASING: {
        vehiclePrice: 1,
        onTheRoadAdditionalCosts: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        downPayment: 6,
        leasingPayment: 7
      },
      CASHBUY: {
        listPrice: 1,
        vehiclePriceCashBuy: 2,
        onTheRoadAdditionalCosts: 3,
        vehicleTireTax: 4,
        vehicleEffectivePrice: 5,
        packagesAttributes: 6,
        winterTireTax: 7,
        subTotalPrice: 8
      },
      FINANCE: {}
    },
    pdf: {
      LEASING: {
        vehiclePrice: 1,
        onTheRoadAdditionalCosts: 2,
        totalLeasingCost: 3,
        leasingDuration: 4,
        mileage: 5,
        downPayment: 6,
        leasingPayment: 7
      },
      CASHBUY: {
        listPrice: 1,
        vehiclePriceCashBuy: 2,
        onTheRoadAdditionalCosts: 3,
        vehicleTireTax: 4,
        vehicleEffectivePrice: 5,
        packagesAttributes: 6,
        winterTireTax: 7,
        subTotalPrice: 8
      },
      FINANCE: {}
    }
  },
  NL: {
    vehicleDetails: {
      LEASING: {
        listPrice: 1,
        leasingDuration: 2,
        mileage: 3,
        leasingPayment: 4,
        // Monthly Rate
        packagesAttributes: 5
      },
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePriceCashBuy: 3,
        packagesAttributes: 4,
        subTotalPrice: 5
      }
    },
    orderSummary: {
      LEASING: {
        leasingPayment: 1,
        // Monthly Rate
        annualMileageAndDuration: 2
      },
      CASHBUY: {
        subTotalPrice: 1
      }
    },
    pdf: {
      LEASING: {
        listPrice: 1,
        leasingDuration: 2,
        mileage: 3,
        downPayment: 4,
        // Monthly Rate?
        packagesAttributes: 5
      },
      CASHBUY: {
        listPrice: 1,
        onTheRoadAdditionalCosts: 2,
        vehiclePriceCashBuy: 3,
        packagesAttributes: 4,
        subTotalPrice: 5
      }
    }
  },
  DEFAULT: {
    vehicleDetails: {
      LEASING: {
        vehiclePrice: 1,
        totalLeasingCost: 2,
        leasingDuration: 3,
        mileage: 4,
        onTheRoadAdditionalCosts: 5,
        downPayment: 6,
        leasingPayment: 7
      },
      FINANCE: {
        vehiclePrice: 1,
        totalLeasingCost: 2,
        leasingDuration: 3,
        mileage: 4,
        onTheRoadAdditionalCosts: 5,
        downPayment: 6,
        leasingPayment: 7
      },
      CASHBUY: {
        listPrice: 1,
        environmentalBonus: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    orderSummary: {
      LEASING: {
        vehiclePrice: 1,
        totalLeasingCost: 2,
        leasingDuration: 3,
        mileage: 4,
        onTheRoadAdditionalCosts: 5,
        downPayment: 6,
        leasingPayment: 7
      },
      FINANCE: {
        vehiclePrice: 1,
        totalLeasingCost: 2,
        leasingDuration: 3,
        mileage: 4,
        onTheRoadAdditionalCosts: 5,
        downPayment: 6,
        leasingPayment: 7
      },
      CASHBUY: {
        listPrice: 1,
        environmentalBonus: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    },
    pdf: {
      LEASING: {
        vehiclePrice: 1,
        totalLeasingCost: 2,
        leasingDuration: 3,
        mileage: 4,
        onTheRoadAdditionalCosts: 5,
        downPayment: 6,
        leasingPayment: 7
      },
      FINANCE: {
        vehiclePrice: 1,
        totalLeasingCost: 2,
        leasingDuration: 3,
        mileage: 4,
        onTheRoadAdditionalCosts: 5,
        downPayment: 6,
        leasingPayment: 7
      },
      CASHBUY: {
        listPrice: 1,
        environmentalBonus: 2,
        vehiclePriceCashBuy: 3,
        onTheRoadAdditionalCosts: 4,
        packagesAttributes: 5,
        subTotalPrice: 6
      }
    }
  }
};
function r(i, a, n) {
  const e = t[i] ?? t.DEFAULT;
  return !e || !e[a] ? {} : e[a][n] ?? {};
}
const c = {
  at: ["DE"],
  be: ["FR", "NL"],
  ch: ["DE", "FR", "IT"],
  de: ["DE"],
  gb: ["EN"],
  es: ["ES"],
  fr: ["FR"],
  it: ["IT"],
  nl: ["NL"],
  pt: ["PT"],
  se: ["SV"]
};
export {
  l as appMarketConfig,
  t as attributesOrderPerMarketAndPaymentTypeConfig,
  r as getPaymentConfig,
  c as hreflangCountries
};
